<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="config-edit-tab-info">
        <!-- Avatar Row -->
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="flex items-start flex-col sm:flex-row">
                </div>
            </div>
        </div>

        <!-- Address Row -->
        <div class="vx-row">
            <!-- Address Col -->
            <div class="vx-col w-full md:w-1/2">
                <!-- Col Header -->
                <div class="flex items-end mt-base">
                    <span class="leading-none font-medium">Banner</span>
                </div>

                <!-- Col Content -->
                <div>
                    <div class="mb-2 mt-2">
                        <img v-if="banner" :src="banner.value" style="width:100%" >
                    </div>
                    <div>
                        <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">
                            {{ data.name }}
                        </p>
                        <input
                            type="file"
                            class="hidden"
                            ref="upload_banner_input"
                            @change="upload_banner"
                            accept="image/*"
                        />

                        <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
                        <!-- <vs-button class="mr-4 mb-4">Change Avatar</vs-button> -->
                        <vs-button
                            type="border"
                            class="mr-4"
                            @click="$refs.upload_banner_input.click()"
                            >Upload Photo</vs-button
                        >

                        <vs-button
                            type="border"
                            color="danger"
                            @click="remove_banner()"
                            >Remove Photo</vs-button
                        >
                    </div>
                </div>
            </div>
            <!-- Company Col -->
            <div class="vx-col w-full md:w-1/2">
            </div>
        </div>
        <!-- Save & Reset Button -->
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button
                        class="ml-auto mt-2"
                        @click="save_changes"
                        :disabled="!validateForm"
                        >Save Changes</vs-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from "vue-select";
import axios from '@/axios.js'

// Store Module
import moduleConfigManagement from "@/store/config-management/moduleConfigManagement.js";

export default {
    components: {
        vSelect,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            data_local: JSON.parse(JSON.stringify(this.data)),
            logo: null,
            banner: null,
        };
    },
    watch: {
        data_local: {
            handler(val){ 
                console.log(element)
                val.results.forEach(element => {
                });
            },
            deep: true
        },
    },
    computed: {
        validateForm() {
            return true;
            // return !this.errors.any();
        },
        // banner: {
        //     get : function() {
        //         this.data_local.results.forEach(element => {
        //             if (element.key == 'BANNER') {
        //                 console.log(element)
        //                 return element
        //             }
        //         });
        //     }
        // },
        // logo: {
        //     get : function() {
        //         this.data_local.results.forEach(element => {
        //             if (element.key == 'LOGO') {
        //                 console.log(element)
        //                 return element
        //             }
        //         });
        //     }
        // }
    },
    methods: {
        capitalize(str) {
            return str;
            // return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
        },
        fetch_logo_data() {
            this.$store
                .dispatch("configManagement/fetchConfig", 1)
                .then((res) => {
                    this.logo = res.data
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        fetch_banner_data() {
            this.$store
                .dispatch("configManagement/fetchConfig", 2)
                .then((res) => {
                    this.banner = res.data
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        save_changes() {
            /* eslint-disable */
            if (!this.validateForm) return;

            // Here will go your API call for updating data
            // You can get data in "this.data_local"

            /* eslint-enable */
            const logoId = this.logo.id;
            const logo = this.logo;
            this.$store
                .dispatch("configManagement/updateConfig", {
                    configId: logoId,
                    item: logo,
                })
                .then((res) => {
                    this.$vs.notify({
                        title: "Success",
                        text: "Update logo successfully",
                        iconPack: "feather",
                        icon: "icon-check-circle",
                        color: "success",
                    });
                })
                .catch((err) => {
                    console.error(err);
                });


            const bannerId = this.banner.id;
            const banner = this.banner;
            this.$store
                .dispatch("configManagement/updateConfig", {
                    configId: bannerId,
                    item: banner,
                })
                .then((res) => {
                    this.$vs.notify({
                        title: "Success",
                        text: "Update banner successfully",
                        iconPack: "feather",
                        icon: "icon-check-circle",
                        color: "success",
                    });
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        reset_data() {
            this.data_local = JSON.parse(JSON.stringify(this.data));
        },
        remove_logo() {
            this.logo.value = null;
            this.$refs.upload_logo_input.value = null;
        },
        remove_banner() {
            this.banner.value = null;
            this.$refs.upload_banner_input.value = null;
        },
        upload_logo(e) {
            console.log(e);
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;

            let formData = new FormData();
            formData.append("image", files[0]);
            this.$refs.upload_logo_input.value = null;
            axios({
                method: "post",
                url: `/file/`,
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then((response) => {
                    if (response.data) {                    
                        this.logo.value = response.data.image;
                    }
                })
                .catch((error) => {
                    console.log(error)
                });
        },
        upload_banner(e) {
            console.log(e);
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;

            let formData = new FormData();
            formData.append("image", files[0]);
            this.$refs.upload_banner_input.value = null;
            axios({
                method: "post",
                url: `/file/`,
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then((response) => {
                    if (response.data) {                    
                        this.banner.value = response.data.image;
                    }
                })
                .catch((error) => {
                    console.log(error)
                });
        },
    },
    created() {
        // Register Module configManagement Module
        if (!moduleConfigManagement.isRegistered) {
            this.$store.registerModule("configManagement", moduleConfigManagement);
            moduleConfigManagement.isRegistered = true;
        }
        this.fetch_logo_data();
        this.fetch_banner_data();
    },
};
</script>
